import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_written_recs_of_disciplinary_actions_maintained_in_wrkrs_pe'

export const dataPointDefinition = {
  retracedId: 'are_written_recs_of_disciplinary_actions_maintained_in_wrkrs_pe',
  name: "Are written records of disciplinary actions maintained in workers' personnel files?",
  description:
    "The intent of this question is to understand if facility maintains written records of disciplinary actions in worker files. \r\r\n\r\r\nFor example if the facility issues written warnings, but does not include at least a physical copy of the written warning in the worker's file, answer No.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'discp-6',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 11600,
  sectionId: '2.2.4.4',
  impactArea: 'Discipline',
  impactAreaId: 'DISCIPLINE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
